import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import Navbar from '../../components/common/navbar';
import { Paper } from '@mui/material'
import Footer from '../../components/common/footer';
import FacultyCard from '../../components/faculty/card';
import api from '../../API/api';

function Parameter() {

  let { id, school } = useParams();
  const [faculty, setFaculty] = useState();

  function getFaculties(data) {
    api.getFaculty(data).then(res => {
      setFaculty(res.data.faculties)
    }).catch(err => {
    })
  }

  useEffect(() => {
    getFaculties(id);
  }, [id])


  return (
    <>
      <Navbar />
      <div className='my-2'>
        <Paper elevation={3}>
          <div className='p-5'>
            <h1 className='text-center'>Faculties of {school.replace(/-/g, ' ')}</h1>
            <div className='row justify-content-center'>
              <FacultyCard faculty={faculty} />
            </div>
          </div>
        </Paper>
      </div>
      <Footer />
    </>
  )
}

export default Parameter